import { Box, Flex } from '@chakra-ui/react';

import { MeshMavenGreen } from 'assets/assetsV1/iconComponents';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { MESH_RECOMMENDATIONS } from '../constants';

export const LifecycleMeshRecommends = ({
  points = MESH_RECOMMENDATIONS,
}: {
  points: string | { points: string[] };
}) => {
  if (typeof points === 'object' && points !== null && 'heading' in points) {
    const hasPoints = points?.points?.length > 0;
    return (
      <Flex w="100%" h="auto" borderRadius="8px">
        <MeshMavenGreen boxSize="80px" mr="16px" />
        <Box
          sx={{
            border: '1px solid  #DBF2D3',
            borderRadius: '8px',
            background: '#F9FDF8',
          }}
        >
          <TextBodyMedium color="#2F8133" p={hasPoints ? '12px 0px 0px 12px' : '12px'}>
            {points.heading}
          </TextBodyMedium>
          {hasPoints && (
            <TextBodyMedium color="#2F8133">
              <ul style={{ padding: '12px 28px', margin: 0 }}>
                {/* @ts-expect-error points */}
                {points?.points?.map((recommendation) => <li style={{ marginBottom: '4px' }}>{recommendation}</li>)}
              </ul>
            </TextBodyMedium>
          )}
        </Box>
      </Flex>
    );
  }

  if (typeof points === 'object' && points !== null) {
    const hasPoints = points?.points?.length > 0;

    return (
      <Flex w="100%" h="auto" borderRadius="8px">
        <MeshMavenGreen boxSize="80px" mr="16px" />
        <Box
          sx={{
            border: '1px solid  #DBF2D3',
            borderRadius: '8px',
            background: '#F9FDF8',
          }}
        >
          {hasPoints && (
            <TextBodyMedium color="#2F8133">
              <ul style={{ padding: '12px 28px', margin: 0 }}>
                {/* @ts-expect-error points */}
                {points?.points?.map((recommendation) => <li style={{ marginBottom: '4px' }}>{recommendation}</li>)}
              </ul>
            </TextBodyMedium>
          )}
        </Box>
      </Flex>
    );
  }
  return (
    <Flex w="100%" h="auto" borderRadius="8px">
      <MeshMavenGreen boxSize="80px" mr="16px" />
      <Flex
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{
          border: '1px solid  #DBF2D3',
          borderRadius: '8px',
          background: '#F9FDF8',
        }}
      >
        <Flex flexDirection="column" p="12px 12px">
          <TextBodyMedium color="#2F8133">{points}</TextBodyMedium>
        </Flex>
      </Flex>
    </Flex>
  );
};
